import { render, staticRenderFns } from "./subjectAdult.vue?vue&type=template&id=d95f1fa6&scoped=true"
import script from "./subjectAdult.vue?vue&type=script&lang=js"
export * from "./subjectAdult.vue?vue&type=script&lang=js"
import style0 from "./subjectAdult.vue?vue&type=style&index=0&id=d95f1fa6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95f1fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d95f1fa6')) {
      api.createRecord('d95f1fa6', component.options)
    } else {
      api.reload('d95f1fa6', component.options)
    }
    module.hot.accept("./subjectAdult.vue?vue&type=template&id=d95f1fa6&scoped=true", function () {
      api.rerender('d95f1fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/subjectAdult.vue"
export default component.exports